module.exports = __webpack_public_path__ + "static/media/client-hub.cb6e6103.png";